import * as yup from 'yup';

export const FormSignupShipperValidationSchema = (role: string) => {
  return yup.object({
    acceptTerms: yup
      .bool()
      .oneOf([true], 'Accept Terms & Conditions is required')
  });
};